/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientsList/view.blocks to change it.
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Filters from './Filters/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import styles from './view.module.css'
let Patients = React.lazy(() => import('./Patients/index'))



/** @type {import('Simple/types.js').View} */
export default function PatientsList({
  children,
  viewPath = "/App/Account/Content/PatientsList"
  
}) {
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={0}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 overflowX="hidden"
 overflowY="hidden"
>
{childProps => (
<div
  data-testid="PatientsList.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Filters
  viewPath={`${viewPath}/Filters`}
/>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Patients
{...childProps}
  viewPath={`${viewPath}/Patients`}
/>
)}
</SuspenseBoundary>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}